// vue
import { useStore } from '@/store';

// models
import { MeasureRecord } from '@/vue3/api/models';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useMeasureRecordService = () => {
    const store = useStore();
    const { apiUrl } = store.state;
    const axios = useAxios();

    // methods
    const getAllMeasureRecordsByCourseSchemaId = async (
        courseSchemaId: number,
    ) => {
        const res = await axios.get(
            `${apiUrl}/measure-record/course-schema/${courseSchemaId}`,
        );
        return res.data;
    };

    const createMeasureRecord = async (
        features: any,
    ): Promise<MeasureRecord> => {
        const res = await axios.post(
            `${apiUrl}/measure-record/${store.getters.currentCourseSchema.id}`,
            features,
        );
        return res.data;
    };

    const deleteMeasureRecord = async (id: number) => {
        const res = await axios.deleteId(`${apiUrl}/measure-record/${id}`);

        return res.data;
    };

    return {
        getAllMeasureRecordsByCourseSchemaId,
        createMeasureRecord,
        deleteMeasureRecord,
    };
};
